import VueApollo from '../../lib/utils/vue3compat/vue_apollo.js?vue3';
import createDefaultClient from '../../lib/graphql.js?vue3';

export const apolloProvider = new VueApollo({
  defaultClient: createDefaultClient(),
});
